import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSearch,
    faEllipsisV,
  faEye,
  faPlus,
  faEdit,
  faTrash,
  faCheckCircle,
  faTimesCircle,
  faRupeeSign,
  faComment,
  faRedo,
  faCross,
  faPhoneVolume,
  faHome,
  faMinus,
  faTram,
  faSignature,
  faDesktop,
  faDatabase,
  faWrench,
  faDownload,
  faEnvelope,
  faQuestion,
  faDolly,
  faPager,
  faTimes,
  faCircleNotch,
  faUpload,
    faArchive
} from '@fortawesome/free-solid-svg-icons'
import { faApple } from '@fortawesome/free-brands-svg-icons'

export const ICONS = {
  EDIT: <FontAwesomeIcon icon={faEdit} />,
  SEARCH: <FontAwesomeIcon icon={faSearch} />,
  VIEW: <FontAwesomeIcon icon={faEye} />,
  REFRESH: <FontAwesomeIcon icon={faRedo} />,
  PLUS: <FontAwesomeIcon icon={faPlus} />,
  MENU: <FontAwesomeIcon icon={faEllipsisV} />,
  DELETE: <FontAwesomeIcon icon={faTrash} />,
  RETURN: <FontAwesomeIcon icon={faArchive} />,
  COMMENTS: <FontAwesomeIcon icon={faComment} />,
  ERROR: <FontAwesomeIcon icon={faCross} />,
  CALL: <FontAwesomeIcon icon={faPhoneVolume} />,
  HOME: <FontAwesomeIcon icon={faHome} />,
  CLOSE: <FontAwesomeIcon icon={faMinus} />,
  HOLIDAY: <FontAwesomeIcon icon={faTram} />,
  SIGNATURE: <FontAwesomeIcon icon={faSignature} />,
  MAC: <FontAwesomeIcon icon={faDesktop} />,
  IOS: <FontAwesomeIcon icon={faApple} />,
  DELIVERY: <FontAwesomeIcon icon={faDatabase} />,
  SETTINGS: <FontAwesomeIcon icon={faWrench} />,
  DOWNLOAD: <FontAwesomeIcon icon={faDownload} />,
  EMAIL: <FontAwesomeIcon icon={faEnvelope} />,
  QUERY: <FontAwesomeIcon icon={faQuestion} />,
  LOG: <FontAwesomeIcon icon={faDolly} />,
  SMS: <FontAwesomeIcon icon={faPager} />,
  UPLOAD: <FontAwesomeIcon icon={faUpload} />,
  CHECKED: <FontAwesomeIcon icon={faCheckCircle} />,
  WAITING: <FontAwesomeIcon icon={faCircleNotch} />,
  SUCCESS_TICK: <FontAwesomeIcon icon={faCheckCircle} />,
  FAILURE_TICK: (
    <FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />
  ),
  RUPEE: <FontAwesomeIcon icon={faRupeeSign} />,
  CLOSE2: <FontAwesomeIcon icon={faTimes} />,
}
